import React from 'react';

import { Comment } from './index'
import Divider from '../../atoms/Divider'

class CommentList extends React.Component {

	render() {

		if(!this.props.comments || !this.props.comments.length) {
			return <Divider label="no posts yet" />
		}

		return this.props.comments.map(({ id, body, user, votes, files, weblinks, children, dateCreated, dateEdited }) => {

			return (
				<React.Fragment key={id}>
					<Comment 
						id={id} 
						message={body} 
						user={user} 
						date={dateCreated}
						dateEdited={dateEdited}
						children={children}
						votes={votes}
						files={files}
						weblinks={weblinks}  />
				</React.Fragment>
			);
		})
	}
}

export default CommentList


// WEBPACK FOOTER //
// ./src/components/comment/CommentList.js